module.exports = __webpack_public_path__ + "static/media/2DGACM10.980dd7e4.jpg";